import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l1.41 1.41.59.59H20v10z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M8 14h4v3l4-4-4-4v3H8z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M10.59 7.41 9.17 6H4v12h16V8h-8.83l-.58-.59zM12 9l4 4-4 4v-3H8v-2h4V9z",
  opacity: ".3"
}, "2")], 'DriveFileMoveTwoTone');